import { ChartScatterPlotHexbinIcon } from './ChartScatterPlotHexbinIcon';

/**
 * author: Austin Andrews
 * id 852E3EF2-942E-42C5-87BB-E1193EBD3E0C
 * name chart-scatter-plot-hexbin
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-scatter-plot-hexbin.svg
 * tags
 * - Math 
 */
export const ReportScatterPlotHexbinIcon = ChartScatterPlotHexbinIcon;
export default ReportScatterPlotHexbinIcon